import useUserInfo from "./useUserInfo";

const useAuth = () => {
  const { isLoggedIn } = useUserInfo();
  return isLoggedIn;
};

export default useAuth;
